import { render, staticRenderFns } from "./NOTAMs.vue?vue&type=template&id=3dc6b6f9&scoped=true&"
import script from "./NOTAMs.vue?vue&type=script&lang=js&"
export * from "./NOTAMs.vue?vue&type=script&lang=js&"
import style0 from "./NOTAMs.vue?vue&type=style&index=0&id=3dc6b6f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc6b6f9",
  null
  
)

export default component.exports